module.exports = __webpack_public_path__ + "img/graphs.7df3332a.png";